import React, { useState, useMemo, useEffect } from 'react';
import axios from 'axios';

// import { useNavigate } from 'react-router-dom';
import { ContactingrecipeColumns } from '../components/contactingrecipe_columns'
import MainLayout from '../layout/MainLayout'
import BasicTable from '../components/BasicTable'
import ContactingrecipeNew from '../new_pages/ContactingrecipeNew';
import useDeleteWithConfirmation from '../components/useDeleteWithConfirmation';
import DeleteConfirmation from '../components/DeleteConfirmation';
import { formatTimestampNow } from '../utils/functions';
import { convertCommaToDotForFloatFields, setDefaultForEmptyNumberFields, handleFocus, handleBlur, validateField } from '../utils/functions';
import PopupContactingmethod from '../components/PopupContactingmethod';
import IncorrectInputModalModal from '../components/IncorrectInputModal'; // Importiere die Modal-Komponente zur Ausgabe bei Fehleingaben vom User
import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/ChangeInputArea.css'


function ContactingrecipePage() {
  
  // const navigate = useNavigate();
  const access_token = window.localStorage.getItem('access_token');

  const [contactingrecipeAll, setContactingrecipeAll] = useState([]); // Zustand für contactingrecipe-Tabellendaten
  const [machineConfigurationOptions, setMachineConfigurationOptions] = useState([]); // Zustand für Maschinenkonfigurations-Daten
  const [yarnOptions, setYarnOptions] = useState([]); // Zustand für Funktionsgarn-Daten
  const [basicYarnOptions, setBasicYarnOptions] = useState([]); // Zustand für Traegergarn-Daten
  const [contactingmethodOptions, setContactingmethodOptions] = useState([]); // Zustand für Kontaktierungsmethoden
  const [institutionOptions, setInstitutionOptions] = useState([]);

  const [glueOptions, setGlueOptions] = useState([]);
  const [solderingagentOptions, setSolderingagentOptions] = useState([]);
  const [fluxOptions, setFluxOptions] = useState([]);
  const [crimpshapeOptions, setCrimpshapeOptions] = useState([]);
  const [knottypeOptions, setKnottypeOptions] = useState([]);
  const [embroiderypatternOptions, setEmbroiderypatternOptions] = useState([]);

  const [glueTemperatureUnitOptions, setGlueTemperatureUnitOptions] = useState([]);
  const [solderTemperatureUnitOptions, setSolderTemperatureUnitOptions] = useState([]);

  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false); // für Popup Neuer Datensatz
  const [copiedData, setCopiedData] = useState(null); // Zustand für kopierte Daten
  const [clickedAnyIcon, setClickedAnyIcon] = useState(false); // Zustandsvariable, um zu ueberpruefen, welches Symbol geklickt wurde
  const [clickedIcon, setClickedIcon] = useState(null);

  const [newSelectedRowID, setNewSelectedRowID] = useState(null); // Zustand um neu angelegte Datensaetze in der Tabelle zu markieren

  const [isContactingmethodPopupOpen, setIsContactingmethodPopupOpen] = useState(false); // für Popup Kontaktierungsmethode
  const [dataContactingmethod, setDataContactingmethod] = useState({});
  const [fieldsContactingmethod, setFieldsContactingmethod] = useState([]);
  const [configTitle, setConfigTitle] = React.useState('');  // Neuer State für den Oberbegriff

  const [errors, setErrors] = useState({}); // Zustand für Fehler pro Feld
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // Zustand für die Anzeige des Modals
  
  const id_institution = window.localStorage.getItem('id_institution');
  const id_role = window.localStorage.getItem('id_role');
  // const warningThreshold = window.localStorage.getItem("warning_threshold");

  const can_create_contactingrecipe = JSON.parse(window.localStorage.getItem('can_create_contactingrecipe'));
  const can_update_contactingrecipe = JSON.parse(window.localStorage.getItem('can_update_contactingrecipe'));
  const can_delete_contactingrecipe = JSON.parse(window.localStorage.getItem('can_delete_contactingrecipe'));
  

  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState ({
    id_contactingrecipe: '',
    name: '',
    institution_name: '',
    machine_configuration_name: '',
    product: '', // gehoert zum machine_configuration_name - wird nur in Tabelle angezeigt
    basic_yarn_name: '',
    yarn_1_name: '',
    yarn_2_name: '',
    contactingmethod_name: '',
    prediction: '',
    others: '',
    all_can_read: false, // checkbox mit boolean-Wert initialisieren
    timestamp: '',
  })

  // Funktion, um den Zustand 'post' basierend auf der Kontaktierungsmethode-Variante zu aktualisieren
  const updatePost = (variant, data) => {
    if (!data || !variant) {
      console.error('updatePost called with missing data or variant:', { variant, data });
      return;
    }

    const variantData = data.knit_contactingvariant[0];

    switch (variant) {
      case 'Kleben':
        setPost((prevState) => ({
          ...prevState,
          id_bonding: variantData.id_bonding,
          glue_name: variantData.glue_name,
          glue_own: variantData.glue_own,
          glue_temperature: variantData.glue_temperature,
          unit_glue_temperature_name: variantData.unit_glue_temperature_name,
          bonding_duration: variantData.bonding_duration,
          quantity: variantData.quantity,
          curing: variantData.curing,
          pressure: variantData.pressure,
          bonding_length: variantData.bonding_length,
        }));
        break;
      case 'Löten':
        setPost((prevState) => ({
          ...prevState,
          id_solder: variantData.id_solder,
          solder_temperature: variantData.solder_temperature,
          unit_solder_temperature_name: variantData.unit_solder_temperature_name,
          solder_duration: variantData.solder_duration,
          flux_name: variantData.flux_name,
          flux_own: variantData.flux_own,
          solder_length: variantData.solder_length,
          soldering_agent_name: variantData.soldering_agent_name,
          soldering_agent_own: variantData.soldering_agent_own,
        }));
        break;
      case 'Crimpen':
        setPost((prevState) => ({
          ...prevState,
          id_crimp: variantData.id_crimp,
          crimp_power: variantData.crimp_power,
          crimp_length: variantData.crimp_length,
          diameter: variantData.diameter,
          crimpshape_name: variantData.crimpshape_name,
        }));
        break;
      case 'Knoten':
        setPost((prevState) => ({
          ...prevState,
          id_knot: variantData.id_knot,
          knottype_name: variantData.knottype_name,
          knottype_own: variantData.knottype_own,
          knot_power: variantData.knot_power,
        }));
        break;
      case 'Sticken_Umwickeln':
        setPost((prevState) => ({
          ...prevState,
          id_embroidery: variantData.id_embroidery,
          embroiderypattern_name: variantData.embroiderypattern_name,
          embroiderypattern_own: variantData.embroiderypattern_own,
          embroidery_length: variantData.embroidery_length,
          embroidery_yarn_name: variantData.embroidery_yarn_name,
          embroidery_basic_yarn_name: variantData.embroidery_asic_yarn_name,
        }));
        break;
      default:
        setPost((prevState) => ({
          ...prevState,
          id_contactingrecipe: '',
          name: '',
          institution_name: '',
          machine_configuration_name: '',
          product: '', // gehoert zum machine_configuration_name - wird nur in Tabelle angezeigt
          basic_yarn_name: '',
          yarn_1_name: '',
          yarn_2_name: '',
          contactingmethod_name: '',
          prediction: '',
          others: '',
          all_can_read: false, // checkbox mit boolean-Wert initialisieren
          timestamp: '',
        }));
    }
  };

  // Funktion zum Leeren der Eingabefelder
  const clearFields = () => {
    setPost({
      id_contactingrecipe: '',
      name: '',
      institution_name: '',
      machine_configuration_name: '',
      product: '',
      basic_yarn_name: '',
      yarn_1_name: '',
      yarn_2_name: '',
      contactingmethod_name: '',
      prediction: '', 
      others: '',
      all_can_read: false,
      timestamp: '',

      glue_name: '',
      glue_own: '',
      glue_temperature: '',
      unit_glue_temperature_name: '',
      bonding_duration: '',
      quantity: '',
      curing: '',
      pressure: '',
      bonding_length: '',
      soldering_agent_name: '',
      soldering_agent_own: '',
      solder_temperature: '',
      solder_duration: '',
      unit_solder_temperature_name: '',
      flux_name: '',
      flux_own: '',
      solder_length: '',
      crimp_power: '',
      crimp_length: '',
      diameter: '',
      crimpshape_name: '',
      knottype_name: '',
      knottype_own: '',
      knot_power: '',
      embroiderypattern_name: '',
      embroiderypattern_own: '',
      embroidery_length: '',
      embroidery_yarn_name: '',
      embroidery_basic_yarn_name: ''
    });
    hideFieldsContactingmethod(); // zusaetzliche Felder Kontaktierungsmethode verbergen
    setErrors({}); // Fehlerzustaende zurücksetzen
  };


  // useEffect wird bei jedem neuen Laden der Seite ausgeführt
  useEffect(() => {
    fetchContactingrecipeAll();
    fetchMachineConfigurationOptions();
    fetchYarnOptions();
    fetchBasicYarnOptions();
    fetchContactingmethodOptions();
    fetchInstitutionOptions();
    fetchGlueOptions();
    fetchSolderingagentOptions();
    fetchFluxOptions();
    fetchCrimpshapeOptions();
    fetchKnottypeOptions();
    fetchEmbroiderypatternOptions();

    fetchUnitOptions('glue_temperature_unit', setGlueTemperatureUnitOptions);
    fetchUnitOptions('solder_temperature_unit', setSolderTemperatureUnitOptions);
  }, []); 




  // useEffect für die Aktualisierung von 'post', wenn 'dataContactingmethod' aktualisiert wurde
  useEffect(() => {
    if (dataContactingmethod && Object.keys(dataContactingmethod).length > 0) {
      const variant = data.find(row => row.id_contactingrecipe === post.id_contactingrecipe)?.contactingmethod_name || '';

      updatePost(variant, dataContactingmethod);
    }
  }, [dataContactingmethod, post.contactingmethod_name]);


  /*useEffect(() => {

    const checkTokenExpiry = () => {
      console.log("Initializing token expiry check...");

      const expiresAt = window.localStorage.getItem("expires_at");
      if (!expiresAt) return;

      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const timeLeft = expiryDate - now;

      if (timeLeft <= 0) {
        logoutUser();
      } else if (timeLeft <= parseInt(warningThreshold, 10)) { // Warnschwelle von 1 Minuten
        // Zeige Warnung
        showExpiryWarning();
      }        
    };

    const logoutUser = () => {
      console.log("Logging out user due to token expiry.");
      window.localStorage.clear(); // Bereinige gespeicherte Daten
      navigate('/'); // Weiterleitung zur Login-Seite
      
    };
  
    const showExpiryWarning = () => {
      console.log("Warning out user due to token expiry.");
      if (!window.localStorage.getItem("warned_about_expiry")) {
        alert("Ihre Sitzung läuft bald ab. Bitte speichern Sie Ihre Arbeit.");
        window.localStorage.setItem("warned_about_expiry", true); // Verhindert wiederholte Warnungen
      }
    };
   

    // Überwachung alle 5 Sekunden
    const intervalId = setInterval(checkTokenExpiry, 5 * 1000); //5 Sekunden
  
    return () => clearInterval(intervalId); // Cleanup bei unmount
  }, [navigate]); */
  

  // Anzeige der Eingabefelder unter der Tabelle zum Aendern
  const fields = [
    { name: 'name', label: 'Bezeichnung', type: 'text', validate: { required: true} },
    { name: 'machine_configuration_name', label: 'Maschinenkonfiguration', type: 'select', validate: { required: true} },
    { name: 'basic_yarn_name', label: 'Trägergarn', type: 'select', validate: { required: true} },
    { name: 'yarn_1_name', label: 'Funktionsgarn 1', type: 'select', validate: { required: true} },
    { name: 'yarn_2_name', label: 'Funktionsgarn 2', type: 'select', validate: { required: true} },
    { name: 'contactingmethod_name', label: 'Kontaktierungsmethode', type: 'text', validate: { required: true} },
    { name: 'prediction', label: 'Vorhersage', type: 'text' },
    { name: 'others', label: 'Sonstige', type: 'textarea' },
    { name: 'all_can_read', label: 'Freigabe für alle Institutionen', type: 'checkbox' },
  ];


  // zusaetzliche Felder für Kontaktierungsmethode
  const fieldConfigurations = {
    Kleben: [
      { name: 'glue_name', label: 'Verwendeter Klebstoff', type: 'select', unit: null, validate: { required: true} },
      { name: 'glue_own', label: 'Eigener Klebstoff', type: 'text', unit: null },
      { name: 'glue_temperature', label: 'Aushärtetemperatur', type: 'text', unit: 'unit_glue_temperature_name', validate: { float: true} }, 
      { name: 'bonding_duration', label: 'Aushärtedauer', type: 'text', unit: null, unit_fix: 's', validate: { float: true} },
      { name: 'quantity', label: 'Klebstoffmenge', type: 'text', unit: null, unit_fix: 'µl', validate: { float: true} },
      { name: 'curing', label: 'Nachhärtezeit', type: 'text', unit: null, unit_fix: 's', validate: { float: true} },
      { name: 'pressure', label: 'Anpressdruck', type: 'text', unit: null, unit_fix: 'N', validate: { float: true} },
      { name: 'bonding_length', label: 'Mittlere Länge der Verbindungsstelle', type: 'text', unit: null, unit_fix: 'mm' },
    ],
    Löten: [
      { name: 'soldering_agent_name', label: 'Verwendetes Lotmaterial', type: 'select', unit: null, validate: { required: true} },
      { name: 'soldering_agent_own', label: 'Eigenes Lotmaterial', type: 'text', unit: null },
      { name: 'solder_temperature', label: 'Löttemperatur', type: 'text', unit: 'unit_solder_temperature_name', validate: { float: true} },
      { name: 'solder_duration', label: 'Lötzeit', type: 'text', unit: null, unit_fix: 's', validate: { float: true} },
      { name: 'flux_name', label: 'Flussmittel', type: 'select', unit: null },
      { name: 'flux_own', label: 'Eigenes Flussmittel', type: 'text', unit: null },
      { name: 'solder_length', label: 'Länge der Verbindungsstelle', type: 'text', unit: null, unit_fix: 'mm', validate: { float: true} },
    ],
    Crimpen: [
      { name: 'crimp_power', label: 'Crimpkraft', type: 'text', unit: null, unit_fix: 'N', validate: { float: true} },
      { name: 'crimp_length', label: 'Crimplänge', type: 'text', unit: null, unit_fix: 'mm', validate: { float: true} },
      { name: 'diameter', label: 'Durchmesser', type: 'text', unit: null, unit_fix: 'mm', validate: { float: true} },
      { name: 'crimpshape_name', label: 'Crimp Form', type: 'select', unit: null },
    ],
    Knoten: [
      { name: 'knottype_name', label: 'Knotentyp', type: 'select', unit: null, validate: { required: true} },
      { name: 'knottype_own', label: 'Eigener Knotentyp', type: 'text', unit: null },
      { name: 'knot_power', label: 'Auszugskraft', type: 'text', unit: null, unit_fix: 'N', validate: { float: true} },
    ],
    Sticken_Umwickeln: [
      { name: 'embroiderypattern_name', label: 'Stickmuster', type: 'select', unit: null, validate: { required: true} },
      { name: 'embroiderypattern_own', label: 'Eigenes Stickmuster', type: 'text', unit: null },
      { name: 'embroidery_length', label: 'Länge', type: 'text', unit: null, unit_fix: 'mm', validate: { float: true} },
      { name: 'embroidery_yarn_name', label: 'zusätzl. Funktionsgarn', type: 'select', unit: null },
    ],
  };


  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, value, type, checked } = event.target;
    setPost((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  // Funktion zum Einfuegen der Tabellen-Daten
  const fetchContactingrecipeAll = async () => {
    try {
      const param = {
        headers: {
          'idInstitution': id_institution,  
          'idRole': id_role,
          'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(
        `${url_root}/get_all_knit_contactingrecipe_to_role_institution_and_readable_ext`, param
      );

      setContactingrecipeAll(response.data);
      return response.data; // Rueckgabe der aktualisierten Daten
    } catch (error) {
      console.error('Error fetching data:', error);
      return []; // Rueckgabe eines leeren Arrays im Fehlerfall
    }
  };


  // Funktionen für dropdown-Listen
  // Funktion zum Abrufen aller Maschinenconfigurationen
  const fetchMachineConfigurationOptions = async (institutionName) => {
    try {
      const param = {
        headers: {
          'idInstitution': id_institution,
          'institutionName': institutionName,
          'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(
        `${url_root}/get_all_knit_machine_configuration_to_institution_name`, param
      );

      setMachineConfigurationOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der machineConfigurationOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Funktionsgarne (yarn)
  const fetchYarnOptions = async (institutionName) => {
    try {
      const param = {
        headers: {
          'idInstitution': id_institution,
          'institutionName': institutionName,
          'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_yarn_to_institution_name`, param);
      setYarnOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der yarnOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Traegergarne (basic_yarn)
  const fetchBasicYarnOptions = async (institutionName) => {
    try {
      const param = {
        headers: {
          'idInstitution': id_institution,
          'institutionName': institutionName,
          'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_basic_yarn_to_institution_name`, param);
      setBasicYarnOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der basicYarnOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Kontaktierungsmethoden
  const fetchContactingmethodOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_contactingmethod`, param);
      setContactingmethodOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der contactingmethodOptions:', error);
    }
  };


  // Funktion zum Abrufen der Institutionen-Daten
  const fetchInstitutionOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_institution`, param);
      setInstitutionOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der institution options:', error);
    }
  };


  // Funktion zum Abrufen aller Klebstoffe
  const fetchGlueOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_glue`, param);
      setGlueOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der glueOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Loetmittel
  const fetchSolderingagentOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_soldering_agent`, param);
      setSolderingagentOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der solderingagentOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Flussmittel
  const fetchFluxOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_flux`, param);
      setFluxOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der fluxOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Crimpformen
  const fetchCrimpshapeOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_crimpshape`, param);
      setCrimpshapeOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der crimpshapeOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Knotentypen
  const fetchKnottypeOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_knottype`, param);
      setKnottypeOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der knottypeOptions:', error);
    }
  };


  // Funktion zum Abrufen aller Stickmuster
  const fetchEmbroiderypatternOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_embroiderypattern`, param);
      setEmbroiderypatternOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der embroiderypatternOptions:', error);
    }
  };


  // Funktion zum Abrufen und Ermitteln der Masseinheiten nach unit_type
  const fetchUnitOptions = async (unitType, setUnitOptions) => {
    try {
      const param = {
        headers: {
          'unitType': unitType,
          'Authorization': `Bearer ${access_token}`    
        }
      };     
      const response = await axios.get(`${url_root}/get_all_knit_unit_to_type`, param);      
      setUnitOptions(response.data);
    } catch (error) {
      console.error(`Fehler beim Abrufen der ${unitType}UnitOptions:`, error);
    }
  };


  // Vermeidung von Zugriff auf Eigenschaften von null oder leeres Array
  const knitContactingrecipeExtArray = contactingrecipeAll && contactingrecipeAll.knit_contactingrecipe; 
  // Verwendet das knitContactingrecipeExtArray als Daten für die Tabelle
  const data = useMemo(() => knitContactingrecipeExtArray || [], [knitContactingrecipeExtArray]);

  // Definiere den Accessor für die BasicTable
  const accessor = 'id_contactingrecipe';


  // Funktion zur Uebertragung des Datensatzes in die Eingabefelder zum Aendern
  const handleButtonChange = async (id) => {
    if (!id) {
      return;
    }

    setErrors({});

    // Datensatz der übergebenen id_contactingrecipe ermitteln
    const changeContactingrecipeData = data.find(row => row.id_contactingrecipe === id);

    // Wenn kein Datensatz gefunden wird, abbrechen
    if (!changeContactingrecipeData) {
      return;
    }

    // Aktuellen Zeitstempel abrufen und formatieren
    const timestamp = formatTimestampNow();

    setPost({
      id_contactingrecipe: changeContactingrecipeData.id_contactingrecipe,
      name: changeContactingrecipeData.name || '',
      machine_configuration_name: changeContactingrecipeData.machine_configuration_name || '',
      product: changeContactingrecipeData.product || '',
      basic_yarn_name: changeContactingrecipeData.basic_yarn_name || '',
      yarn_1_name: changeContactingrecipeData.yarn_1_name || '',
      yarn_2_name: changeContactingrecipeData.yarn_2_name || '',
      contactingmethod_name: changeContactingrecipeData.contactingmethod_name || '',
      prediction: changeContactingrecipeData.prediction || '',
      others: changeContactingrecipeData.others || '',
      all_can_read: changeContactingrecipeData.all_can_read || false,
      //timestamp: timestamp, // aktueller timestamp
      timestamp: changeContactingrecipeData.timestamp || formatTimestampNow(),
    })

    // Variante für die Kontaktierungsmethode festlegen
    const variant = changeContactingrecipeData.contactingmethod_name || '';
    
    try {
      // Fetch Data und setze state entsprechend
      const contactingVariantData = await fetchContactingvariant(id, variant);
      setDataContactingmethod(contactingVariantData);
      setFieldsContactingmethod(fieldConfigurations[variant] || []);
    } catch (error) {
      console.error('Fehler beim Abrufen der Kontaktierungsdaten:', error);
    }
  };


  /* Callback-Funktion zum Empfangen des clickedIcon von der BasicTable 
    zur Anzeige der zusaetzlichen Eingabefelder nur bei change-icon */
  const handleIconClick = (icon) => {
    setClickedIcon(icon);
  };


  // Funktion zum Aendern des Datensatzes
  const handleSave = async (id) => {
    try {
      if (id === "" || id === undefined) {
        setErrorMessage("Bitte wählen Sie ein Kontaktierungsrezept zum Ändern aus oder legen Sie mit NEU ein neues Kontaktierungsrezept an.");
        setShowErrorModal(true);
        return;
      }

      // Ueberpruefung, ob es noch Fehleingaben gibt
      const hasErrors = Object.values(errors).some(error => error !== '');

      if (hasErrors) {
        // Zeige das Modal, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      setErrors({});

      // Erstellen einer Kopie des Datensatzes, um ihn zu bearbeiten
      const modifiedPost = { ...post };

      // Setze leere Float- und Integer-Felder auf -123
      setDefaultForEmptyNumberFields(modifiedPost, fields, fieldConfigurations);
      // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
      convertCommaToDotForFloatFields(modifiedPost, fields, fieldConfigurations);

      //Kontaktierungsparameter der jeweiligen Methode ändern
      await axios.put(`${url_root}/modify_knit_contactingmethod_to_id`, modifiedPost,
        {
          headers: {
              'Authorization': `Bearer ${access_token}`
          }
        }
      );
      
      await axios.put(`${url_root}/modify_knit_contactingrecipe_to_id`, modifiedPost,
        {
          headers: {
              'Authorization': `Bearer ${access_token}`
          }
        }
      );
      
      newSaveID(id); // Datensatz bleibt in Tabelle markiert
      
      fetchContactingrecipeAll(); // Tabelle aktualisieren
      setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, d.h. icon wird wieder blau TODO: funktioniert nicht für change-icon
      clearFields(); // Aendern-Felder leeren, da der Focus zum Kopieren der Daten neu gesetzt wird, das waere verwirrend
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };


  // Funktion zum Kopieren des Datensatzes
  const handleButtonCopy = async (id) => {
    // Zeile zum Kopieren wird ermittelt
    const copyContactingrecipeData = data.find(row => row.id_contactingrecipe === id);

    // Variante für die Kontaktierungsmethode festlegen
    const variant = copyContactingrecipeData.contactingmethod_name || '';

    try {
      // Fetch Data und setze state entsprechend
      const contactingVariantData = await fetchContactingvariant(id, variant);
      setDataContactingmethod(contactingVariantData);
      setFieldsContactingmethod(fieldConfigurations[variant] || []);

      // Kombiniere die kopierten Rezeptdaten mit den Kontaktierungsmethoden-Daten ohne Unterverzeichnis
      const combinedData = {
        ...copyContactingrecipeData, // Kopierte Rezeptdaten
        ...contactingVariantData, // Kontaktierungsmethoden-Daten auf gleicher Ebene
      };

      // Funktion zur Anpassung der Werte in allen Feldern
      const adjustFields = (data) => {
          if (Array.isArray(data)) {
              return data.map(item => adjustFields(item));
          } else if (typeof data === 'object' && data !== null) {
              Object.keys(data).forEach(field => {
                  if (data[field] === 0 || data[field] === -123 || data[field] === null) {
                      data[field] = ''; // Wert in leeren String umwandeln
                  } else if (typeof data[field] === 'object') {
                      data[field] = adjustFields(data[field]); // Rekursiv für geschachtelte Objekte
                  }
              });
              return data;
          }
          return data;
      };

      // Anpassung auf combinedData anwenden
      const adjustedCombinedData = adjustFields(combinedData);

      // Setze die kombinierten Daten in den Zustand
      setCopiedData(adjustedCombinedData);
    } catch (error) {
      console.error('Fehler beim Abrufen der Kontaktierungsdaten:', error);
    }
    clearFields();
  };


  // Abfrage zum Loeschen Datensatz als popup in extra Komponente und useHook ausgelagert:
  const deleteApiUrl = `${url_root}/delete_knit_contactingrecipe_to_id`;
  // benutzerdefinierter Hook useDeleteWithConfirmation kapselt die Loeschlogik und den Zustand des Bestaetigungs-Popups
  // TODO: nach Löschen wird zur Zeit der darauffolgende Datensatz markiert und dessen delete-icon ist rot - besser kein Datensatz markiert
  const {
    isDeletePopupOpen,
    handleButtonDelete,
    handleConfirmDelete,
    closeDeletePopup,
  } = useDeleteWithConfirmation(
    deleteApiUrl, 
    fetchContactingrecipeAll, 
    clearFields,
  );

  
  // Funktion zum Oeffnen des Popups für das Hinzufuegen eines neuen Eintrags
  const openNewEntryPopup = () => {
    setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf true, wenn das newPopup geöffnet wird
    setIsNewPopupOpen(true);
  };


  // Funktion zum Schliessen des Popups für neue Eintraege
  const closeNewPopup = () => {
    setCopiedData(null); // Setze copiedData auf null, Felder werden geleert
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, damit das icon wieder inaktiv (blau) wird
    hideFieldsContactingmethod();
    setIsNewPopupOpen(false);
    clearFields();
  };


  // Funktion zum Markieren des neuen Datensatzes in BasicTable
  const newSaveID = (id) => {
    setNewSelectedRowID(id) // newSelectedRowID wird auf den Wert der yarn_id gesetzt
  };


  // Funktionen für die zusaetzlichen Felder für die Kontaktierungsmethoden:
  // Funktion zum Verbergen der zusaetzlichen Felder für Kontaktierungsmethode
  const hideFieldsContactingmethod = () => {
    setFieldsContactingmethod([]);
  }


  /* Funktion zum Aufrufen der Kontaktingmethode Infos im Popup-Fenster (Variante) 
    wird in BasicTable bei Klick auf info-icon aufgerufen */
  const handleIconContactingmethodClick = async (id, value) => {

    try {
      // API aufrufen und die Daten abrufen
      const data = await fetchContactingvariant(id, value);
      if (data) {
        // Popup oeffnen mit den abgerufenen Daten
        openContactingmethodPopup(data, value);
      }
    } catch (error) {
      console.error('Fehler beim Aufruf der Kontaktierungsmethode:', error);
    }
  }


  // Funktion zum Abrufen der Untermenues je Kontaktierungsmethode
  const fetchContactingvariant = async (id, value) => {
    try {
      const param = {
        headers: {
          'idContactingrecipe': id,
          'contactingmethodName': value,
          'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_knit_contactingvariant_to_contactingrecipe_and_contactingmethod_ext`, param);

      // Ueberpruefen, ob der Abruf erfolgreich war und Daten vorhanden sind
      if (response && response.data) {
        return response.data;  // Rueckgabe der Daten zur Verwendung in openContactingmethodPopup
      }
      } catch (error) {
        console.error('Fehler beim Abrufen der contactingVariantOptions:', error);
      }
    return null;
  };


  // Funktion zum Oeffnen des Popup Kontaktierungsmethode
  const openContactingmethodPopup = (data, variant) => {
    setDataContactingmethod(data);
    setFieldsContactingmethod(fieldConfigurations[variant] || []);
    setIsContactingmethodPopupOpen(true);
    setConfigTitle(variant);  // Setze den Oberbegriff für die Anzeige im Popup
  };


  // Funktion zum Schliessen des Popup Kontaktierungsmethode
  const closeContactingmethodPopup = () => {
    hideFieldsContactingmethod(); // Felder Kontaktierungsmethode bei Aendern werden wieder verborgen
    setIsContactingmethodPopupOpen(false);
  }


  // Daten aus anderen Tabellen, die als dropdown angezeigt werden sollen:
  const filteredDataMachineConfiguration = machineConfigurationOptions && machineConfigurationOptions.knit_machine_configuration ? machineConfigurationOptions.knit_machine_configuration.filter(item => item.id_machine_configuration !== 0) : [];
  const sortedMachineConfigurationOptions = Array.from(new Set(filteredDataMachineConfiguration.map(item => item.name))).sort();

  const filteredDataYarn = yarnOptions && yarnOptions.knit_yarn ? yarnOptions.knit_yarn.filter(item => item.id_yarn !== 0) : [];
  const sortedYarnOptions = Array.from(new Set(filteredDataYarn.map(item => item.name))).sort();

  const filteredDataBasicYarn = basicYarnOptions && basicYarnOptions.knit_basic_yarn ? basicYarnOptions.knit_basic_yarn.filter(item => item.id_basic_yarn !== 0) : [];
  const sortedBasicYarnOptions = Array.from(new Set(filteredDataBasicYarn.map(item => item.name))).sort();

  const filteredDataInstitution = institutionOptions && institutionOptions.knit_institution ? institutionOptions.knit_institution.filter(item => item.id_institution !== 0) : [];
  const sortedInstitutionOptions = Array.from(new Set(filteredDataInstitution.map(item => item.name))).sort();

  const filteredDataContactingmethod = contactingmethodOptions && contactingmethodOptions.knit_contactingmethod ? contactingmethodOptions.knit_contactingmethod.filter(item => item.id_contactingmethod !== 0) : [];
  const sortedContactingmethodOptions = Array.from(new Set(filteredDataContactingmethod.map(item => item.name)));

  // Daten aus anderen Tabellen für die jeweilige Kontaktierungsmethode
  const filteredDataGlue = glueOptions && glueOptions.knit_glue ? glueOptions.knit_glue.filter(item => item.id_glue !== 0) : [];
  const sortedGlueOptions = Array.from(new Set(filteredDataGlue.map(item => item.name))).sort();

  const filteredDataSolderingagent = solderingagentOptions && solderingagentOptions.knit_soldering_agent ? solderingagentOptions.knit_soldering_agent.filter(item => item.id_soldering_agent !== 0) : [];
  const sortedSolderingagentOptions = Array.from(new Set(filteredDataSolderingagent.map(item => item.name))).sort();

  const filteredDataFlux = fluxOptions && fluxOptions.knit_flux ? fluxOptions.knit_flux.filter(item => item.id_flux !== 0) : [];
  const sortedFluxOptions = Array.from(new Set(filteredDataFlux.map(item => item.name))).sort();

  const filteredDataCrimpshape = crimpshapeOptions && crimpshapeOptions.knit_crimpshape ? crimpshapeOptions.knit_crimpshape.filter(item => item.id_crimpshape !== 0) : [];
  const sortedCrimpshapeOptions = Array.from(new Set(filteredDataCrimpshape.map(item => item.name))).sort();

  const filteredDataKnottype = knottypeOptions && knottypeOptions.knit_knottype ? knottypeOptions.knit_knottype.filter(item => item.id_knottype !== 0) : [];
  const sortedKnottypeOptions = Array.from(new Set(filteredDataKnottype.map(item => item.name))).sort();

  const filteredDataEmbroiderypattern = embroiderypatternOptions && embroiderypatternOptions.knit_embroiderypattern ? embroiderypatternOptions.knit_embroiderypattern.filter(item => item.id_embroiderypattern !== 0) : [];
  const sortedEmbroiderypatternOptions = Array.from(new Set(filteredDataEmbroiderypattern.map(item => item.name))).sort();

  const filteredDataGlueTemperatureUnit = glueTemperatureUnitOptions && glueTemperatureUnitOptions.knit_unit_to_unit_type ? glueTemperatureUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedGlueTemperatureUnitOptions = Array.from(new Set(filteredDataGlueTemperatureUnit.map(item => item.name))).sort();

  const filteredDataSolderTemperatureUnit = solderTemperatureUnitOptions && solderTemperatureUnitOptions.knit_unit_to_unit_type ? solderTemperatureUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedSolderTemperatureUnitOptions = Array.from(new Set(filteredDataSolderTemperatureUnit.map(item => item.name))).sort();


  return (
    <MainLayout openNewEntryPopup={openNewEntryPopup} showNavbar={true} showButtonBar={true} showAllButton={false}>
      <BasicTable 
        columns={ContactingrecipeColumns} 
        accessor={accessor}
        data={data} 
        handleButtonChange={handleButtonChange} 
        handleButtonCopy={handleButtonCopy}
        handleButtonDelete={handleButtonDelete}
        handleIconContactingmethodClick={handleIconContactingmethodClick}
        clearFields={clearFields} // Hier wird die Funktion als Prop übergeben
        newSaveID={newSelectedRowID} // Funktion zum Markieren des neuen Datensatzes in Tabelle uebergeben
        fetchMachineConfigurationOptions={fetchMachineConfigurationOptions}
        fetchYarnOptions={fetchYarnOptions}
        fetchBasicYarnOptions={fetchBasicYarnOptions}
        isAnyIconClicked={clickedAnyIcon}
        showDatasheetIcon={false} // Datasheet icon wird nicht in Tabelle angezeigt
        canCreate={can_create_contactingrecipe}
        canUpdate={can_update_contactingrecipe}
        canDelete={can_delete_contactingrecipe}
        hideFieldsContactingmethod={hideFieldsContactingmethod}
        handleIconClick={handleIconClick}
      />
      <div className='area-under-table'>
        {/* Nur anzeigen, wenn can_update true ist */}
        {can_update_contactingrecipe && (
        <div className='area-change'>
          <div className='box-title'>
            <h3>Hier können Sie die Parameter ändern:</h3>
          </div>

        <div className="field-container">
          {/* Erste Gruppe: fields */}
          <div className="fields-group-contactingrecipe"></div>

        {fields.map(field => {
          const fieldValue = post[field.name];
          // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
          const displayValue = fieldValue < 0 ? '' : fieldValue;

          return (
            <div key={field.name} className="change-input-row">
              <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>  

              <div className="input-with-unit">             
                {field.type === 'select' ? (
                <>
                  <select 
                    onChange={handleInput} 
                    name={field.name} 
                    value={displayValue}
                    onFocus={(event) => handleFocus(event, setErrors)}
                    onBlur={(event) => handleBlur(event, fields, fieldConfigurations, (name, value, rules) => 
                      validateField(name, value, rules, setErrors))}
                  >                   
                    <option value=""></option>
                    {field.name === 'machine_configuration_name' && sortedMachineConfigurationOptions.length > 0 ? (
                      sortedMachineConfigurationOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))
                      ) : field.name === 'basic_yarn_name' && sortedBasicYarnOptions.length > 0 ? (
                        sortedBasicYarnOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'yarn_1_name' && sortedYarnOptions.length > 0 ? (
                        sortedYarnOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'yarn_2_name' && sortedYarnOptions.length > 0 ? (
                        sortedYarnOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                    ) : null}
                  </select>
                    {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
                    {errors[field.name] && (
                      <span className="error-message">{errors[field.name]}</span>
                    )}
                </>

                    ) : field.type === 'checkbox' ? (
                      <div className="change-input-row-checkbox">
                        <input 
                          type="checkbox"
                          name={field.name}
                          checked={post[field.name]}
                          onChange={handleInput}
                        />
                      </div>
                    ) : field.type === 'textarea' ? (
                      <textarea className='textarea'
                        name={field.name}
                        value={displayValue}
                        onChange={handleInput}
                      />
                    ) : (
                      <>               
                        <input // Texteingabefelder
                          type={field.type} 
                          value={displayValue} 
                          onChange={handleInput} 
                          name={field.name} 

                          onFocus={(event) => handleFocus(event, setErrors)}
                          onBlur={(event) => handleBlur(event, fields, fieldConfigurations, (name, value, rules) => 
                            validateField(name, value, rules, setErrors))}

                          // Vorhersage-Feld wird ausgegraut (transparent)                           
                          className={`${field.name === 'prediction' ? 'prediction-field' : ''
                            } ${errors[field.name] ? 'input-error' : ''}`.trim()}
                          
                          // Name des Rezepts (alle user) oder Vorhersage in Prozent (wenn id_role != 1) kann nicht geaendert werden (nur lesen)
                          readOnly={field.name === 'name' || field.name === 'contactingmethod_name' || field.name === 'prediction'}
                        />
                        {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}     
                      </>
                    )}            
                  </div>
                </div>
              );
            })}
          </div>  {/* Ende erste Gruppe: fields */}

          <div className='area-change-button'>
            <button onClick={() => clearFields()}>ABBRECHEN</button>
            <button onClick={() => handleSave(post.id_contactingrecipe)}>SPEICHERN</button>       
          </div>
        </div>        
      )}      
        {/* Dynamische Eingabefelder für Kontaktierungsmethoden, Gruppe: fieldsContactingmethod*/}
        <div className="fields-group-contactingrecipe"> 
        {clickedIcon === 'change' && 
          fieldsContactingmethod.map(field => {
            const fieldValue = post[field.name];
            // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
            const displayValue = fieldValue < 0 ? '' : fieldValue;

          return (
            <div key={field.name} className="change-input-row">
              <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>

                <div className="input-with-unit">
                  {field.type === 'select' ? (
                    <select onChange={handleInput} name={field.name} value={displayValue}>
                      <option value=""></option>
                      {field.name === 'glue_name' && sortedGlueOptions.length > 0 ? (
                        sortedGlueOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'soldering_agent_name' && sortedSolderingagentOptions.length > 0 ? (
                        sortedSolderingagentOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'flux_name' && sortedFluxOptions.length > 0 ? (
                        sortedFluxOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'crimpshape_name' && sortedCrimpshapeOptions.length > 0 ? (
                        sortedCrimpshapeOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'knottype_name' && sortedKnottypeOptions.length > 0 ? (
                        sortedKnottypeOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'embroiderypattern_name' && sortedEmbroiderypatternOptions.length > 0 ? (
                        sortedEmbroiderypatternOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'embroidery_yarn_name' && sortedYarnOptions.length > 0 ? (
                        sortedYarnOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : null}
                    </select>
                      ) : field.type === 'checkbox' ? (
                        <div className="change-input-row-checkbox">
                          <input 
                            type="checkbox"
                            name={field.name}
                            checked={post[field.name]}
                            onChange={handleInput}
                          />
                        </div>
                      ) : (
                  <>
                    <div className="input-with-fixed-unit" key={field.name}>
                      <input
                        type= {field.type}
                        value={displayValue}
                        onChange={handleInput}
                        name={field.name}

                        onFocus={(event) => handleFocus(event, setErrors)}
                        onBlur={(event) => handleBlur(event, fields, fieldConfigurations, (name, value, rules) => 
                          validateField(name, value, rules, setErrors))}

                        // Verkettung der bestehenden Klassen mit der Fehlerklasse
                        className={`${field.unit_fix ? 'input-with-unit-fix' : ''} ${errors[field.name] ? 'input-error' : ''}`}                

                        autoComplete="off" // Hilft den Fokus nicht zu vergessen
                      />
                      {field.unit_fix && <span className="unit-label">{field.unit_fix}</span>}
                      {errors[field.name] && <span className="error-message">{errors[field.name]}</span>} 
                    </div>

                      {field.unit && (  // rendern nur, wenn field.unit einen Wert hat                    
                        <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                          className="unit-dropdown"
                          name={field.unit} // Verwenden Sie field.unit direkt als name
                          value={post[field.unit]} // Verwenden Sie field.unit direkt, um den Wert aus post zu erhalten
                          onChange={handleInput} // Uebergeben Sie Ihre handleInput-Funktion für onChange                 
                        >

                        <option value="" disabled> </option>
                        
                        {field.unit === 'unit_glue_temperature_name' && sortedGlueTemperatureUnitOptions.length > 0 ? (
                          sortedGlueTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_solder_temperature_name' && sortedSolderTemperatureUnitOptions.length > 0 ? (
                          sortedSolderTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        )  : null}
                      </select>
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}
        
      </div> {/*Ende Dynamische Eingabefelder für Kontaktierungsmethoden */}
      </div> {/*Ende area-under-table */}

      {/* für popup NEU */}
      {isNewPopupOpen && (
        <div className="new-popup-overlay">
          <div className="new-popup-content-contactingrecipe">
            <span onClick={closeNewPopup} className="new-popup-close">
              &times;
            </span>
            <ContactingrecipeNew
              closeNewPopup={closeNewPopup}
              fields={fields} // Eingabefelder für neuen Datensatz
              sortedMachineConfigurationOptions={sortedMachineConfigurationOptions}
              sortedYarnOptions={sortedYarnOptions}
              sortedBasicYarnOptions={sortedBasicYarnOptions}
              sortedContactingmethodOptions={sortedContactingmethodOptions}
              sortedInstitutionOptions={sortedInstitutionOptions}
              sortedGlueOptions={sortedGlueOptions}
              sortedSolderingagentOptions={sortedSolderingagentOptions}
              sortedFluxOptions={sortedFluxOptions}
              sortedCrimpshapeOptions={sortedCrimpshapeOptions}
              sortedKnottypeOptions={sortedKnottypeOptions}
              sortedEmbroiderypatternOptions={sortedEmbroiderypatternOptions}
              sortedGlueTemperatureUnitOptions={sortedGlueTemperatureUnitOptions}
              sortedSolderTemperatureUnitOptions={sortedSolderTemperatureUnitOptions}
              fetchContactingrecipeAll={fetchContactingrecipeAll}
              fetchMachineConfigurationOptions={fetchMachineConfigurationOptions}
              fetchYarnOptions={fetchYarnOptions}
              fetchBasicYarnOptions={fetchBasicYarnOptions}
              fetchContactingmethodOptions={fetchContactingmethodOptions}
              copiedData={copiedData}
              newSaveID={newSaveID}
              formatTimestampNow={formatTimestampNow}
              fieldsContactingmethod={fieldsContactingmethod} // Felder der Kontaktierungsmethode
              setFieldsContactingmethod={setFieldsContactingmethod} // zum Setzen der Kontaktierungsmethode 
              fieldConfigurations={fieldConfigurations}
              convertCommaToDotForFloatFields={convertCommaToDotForFloatFields}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              validateField={validateField}
              setErrors={setErrors}
              errors={errors}
              setErrorMessage={setErrorMessage}
              setShowErrorModal={setShowErrorModal}
            />
          </div>
        </div>
      )}

      <PopupContactingmethod
        isContactingmethodPopupOpen={isContactingmethodPopupOpen}
        closeContactingmethodPopup={closeContactingmethodPopup}
        dataContactingmethod={dataContactingmethod}
        fieldsContactingmethod={fieldsContactingmethod}
        configTitle={configTitle}
      />

      <DeleteConfirmation
        isOpen={isDeletePopupOpen}
        onClose={closeDeletePopup}
        onConfirm={handleConfirmDelete}
      />

      {/* Modal zur Fehlermeldung anzeigen, wenn showErrorModal true ist */}
      {showErrorModal && (
        <IncorrectInputModalModal
          message={errorMessage} // Dynamische Nachricht uebergeben
          onClose={() => setShowErrorModal(false)} // Schliesst das Modal
        />
      )}

    </MainLayout>
  )
}

export default ContactingrecipePage
